import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TimelineMapService } from './timeline-map.service'
import { ECharts, registerMap } from 'echarts';
import * as echart from 'echarts';
import * as _ from 'lodash'
import * as map from '../../mapsFile/mapsFile';
import { displayType } from './timeline-map-interface';
import { initOpts } from '../../config/initOpts';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from '../../service/common.service';

@Component({
  selector: 'bcac-timeline-map',
  templateUrl: './timeline-map.component.html',
  styleUrls: ['./timeline-map.component.scss']
})
export class TimelineMapComponent implements OnInit {

  constructor(
    private timelineMapService: TimelineMapService,
    private commonService: CommonService
  ) {
  }
  initOpts;
  ngOnInit() {
    this.initOpts = initOpts;
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      let style = this.commonService.changeFontSize();
      this.echartInstance.setOption({
        baseOption: {
          timeline: {
            label: {
              fontSize: style.fontSize - 1,
              position: style.fontSize - 1
            },
            checkpointStyle: {
              symbolSize: style.fontSize - 2
            },
            controlStyle: {
              itemSize: style.fontSize - 2
            }
          },
          visualMap: [{
            textStyle: {
              fontSize: style.fontSize - 2
            }
          }],
          series: [{
            label: {
              fontSize: style.fontSize - 2
            }
          }]

        },

      })
    })
    this.registerMap(this._bcacMapName, this.mapUrl);
  }

  _bcacMapName: string = "beijing"

  chartOption: any = this.timelineMapService.getTimelineMapDefaultOption();
  _bcacChartTitle: { show: boolean, label: string } = {
    show: true,
    label: "地图"
  }

  // 输入标题
  @Input()
  set bcacChartTitleText(chartTitle: string) {
    this._bcacChartTitle.label = chartTitle
  }
  // 输入标题是否显示
  @Input()
  set bcacChartShowTitle(showTitle: boolean) {
    this._bcacChartTitle.show = showTitle
  }
  // 下载图片文件名
  _bcacChartFileName: string = "图表";
  @Input()
  set bcacChartFileName(fileName: string) {
    this._bcacChartFileName = fileName;
  }


  // 加载等待
  _bcacChartLoading: boolean = false
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }

  geoCoordMap: any = map.geoCoordMap_beijing;
  mapUrl = map.map_bejing;
  // 输入地图名称
  @Input()
  set bcacMapName(bcacMapName: string) {
    let mapName = "", mapUrl: any = null;
    switch (bcacMapName) {
      case "beijing":
        mapName = bcacMapName;
        mapUrl = map.map_bejing;
        this.geoCoordMap = map.geoCoordMap_beijing;
        break;
      case "chengdu":
        mapName = bcacMapName;
        mapUrl = map.map_chengdu;
        this.geoCoordMap = map.geoCoordMap_chengdu;
        break;
      default:
        mapName = "beijing";
        mapUrl = map.map_bejing;
    }
    this._bcacMapName = bcacMapName;
    this.mapUrl = mapUrl
    this.chartOption.baseOption.geo.map = mapName;
    this.registerMap(this._bcacMapName, this.mapUrl);
  }
  // 修改visualMap类型
  @Input()
  set bcacVisualMap(
    visualMap: {
      type: "continuous";
      data: { min: number; max: number; color?: string[] }
    }
      | { type: "piecewise"; data: { [key: string]: any }[] }
  ) {
    this.timelineMapService.changeVisualMap(this.chartOption, this._bcacDisplayType, visualMap);
  }


  // 时间轴数据
  @Input()
  set bcacTimelineData(timelineData: string[]) {
    this.timelineMapService.changeTimelineData(this.chartOption, timelineData);
    this.updateChart();
  }

  // 显示类型（area：默认 point）
  _bcacDisplayType: displayType = 'area';
  @Input()
  set bcacDisplayType(bcacDisplayType: displayType) {
    this._bcacDisplayType = bcacDisplayType;
    this.timelineMapService.changeDisplayType(this.chartOption, bcacDisplayType);
  }

  // 数据
  @Input()
  set bcacChartData(bcacChartData: object[][]) {
    this.timelineMapService.changeChartData(this.chartOption, this._bcacDisplayType, bcacChartData, this.geoCoordMap);
  }


  // 设置映射维度
  @Input()
  set bcacDimension(dimension: number) {
    this.timelineMapService.changeVisualmapDimension(this.chartOption, this._bcacDisplayType, dimension);
  }

  // 设置dimension名
  @Input()
  set bcacDimensionNames(dimensionNames: { [key: string]: string }[]) {
    this.timelineMapService.changeDimensionNames(this.chartOption, this._bcacDisplayType, dimensionNames)
  }

  // visualMap位置
  @Input()
  set bcacVisualMapPosition(position: 'left' | 'right') {
    this.timelineMapService.changeVisualMapPosition(this.chartOption, position)
  }

  // ECharts实例
  echartInstance: ECharts = null;
  onOptionInit(ec) {
    if (ec) {
      this.echartInstance = ec;
    }
  }
  //注册地图
  registerMap(name: string, mapUrl: Object) {
    echart.registerMap(name, mapUrl)
  }
  // 更新图
  updateChart() {
    if (this.echartInstance) {
      this.echartInstance.setOption(this.chartOption, true)
    }
  }

}
